import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { IItem, ISection, formatCurrency, formatDate, formatDateTime, formatDateTimeEx, formatPercentage } from '../../models/group-edit-config';
import { FormControl } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { CompanyService } from '../../../../services/company.service';
import { NtCompany } from '../../models/nt-company';

@Component({
  selector: 'app-group-edit-section-item',
  templateUrl: './group-edit-section-item.component.html',
  styleUrls: ['./group-edit-section-item.component.scss']
})
export class GroupEditSectionItemComponent implements OnInit, OnDestroy {
    @Input() section: ISection;
    @Input() item: IItem;
    @Input() isSelected: boolean;
    sub = new Subject();
    company: NtCompany;

    value: any;

    constructor(private comp: CompanyService) { }

    ngOnInit(): void {
        this.comp.SelectedCompany.pipe(takeUntil(this.sub))
                    .subscribe(c => {
                        this.company = c;
                        if(c){
                            this.getFieldValue();
                        }
                    });

        this.value = this.getFieldValue();
    }


    ngOnDestroy(): void {
        this.sub.next(false);
        this.sub.complete();
    }

    getControl(i: IItem): FormControl{
        return this.section.form.controls[i.fieldName] as FormControl;
    }

    getFieldValue(){
        let v = this.section.data ? ( this.item.displayFieldName  ?   this.section.data[this.item.displayFieldName] :  this.section.data[this.item.fieldName]) : null;
        const valueFormat = this.item.valueFormat;
        const isUSFormat = this.company ? ((this.company.defaultCurrency === 'USD' || this.company.defaultCurrency === 'CAD') ? true: false) : false;
        if(v){
            if(valueFormat){
                if(valueFormat === 'Date'){
                    return formatDate(v, isUSFormat);
                }else if(valueFormat === 'DateTime'){
                    return formatDateTime(v, isUSFormat);
                }else if(valueFormat === 'DateTimeEx'){
                    return formatDateTimeEx(v, isUSFormat);
                }else if(valueFormat === 'Currency'){
                    return formatCurrency(v);
                }else if(valueFormat === 'Percentage'){
                    return formatPercentage(v);
                }else{
                    return v;
                }
            }else{
                if(this.item.control === 'datepicker'){
                    return formatDate(v);
                }else{
                    return v;
                }
            }
        }else if(valueFormat){
            if(valueFormat === 'Percentage'){
                return formatPercentage(v);
            }
            return v;
        }else{
            if(this.item.control === 'checkbox'){
                return false;
            }else{
                return v;
            }
        }
    }
}
